<template>
  <div style="padding-top: 68px">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$parent.goNav('/app')" class="header-download"></a>
      </div>
      <div class="header-center">
        <a @click="$parent.goNav('/')" class="header-logo"> <img  :src="$store.state.appInfo.site_logo || '/static/image/d11_logo_h5.png'" onerror="this.src = '/static/image/d11_logo_h5.png'" width="100%" /> </a>
        <h4 class="header-title hide"></h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
        <a v-if="!$store.state.token" @click="$parent.goNav('/login')" class="header-action" id="login_btn" style="font-size: 12px">登录</a>
      </div>
    </div>

    <!-- 轮播 -->
    <van-swipe :show-indicators="false">
      <van-swipe-item v-for="(item, index) in bannerList" :key="index">
        <img :src="item.src" style="width: 100%" alt="" />
      </van-swipe-item>
    </van-swipe>
    <div class="live-panel">
      <img style="width: 100%" src="/static/image/live_02.jpg" />

      <a id="entergame_btn" href="javascript:void(0);" @click="$parent.openGamePage('ag', 'ag', '')"></a>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>
<script>
export default {
  name: 'zhanzhu',
  data() {
    return {
      bannerList: [
        { src: '/static/image/banner_01.jpg' },
        { src: '/static/image/banner_02.jpg' },
        { src: '/static/image/banner_03.jpg' },
        { src: '/static/image/banner_04.jpg' },
        { src: '/static/image/banner_05.jpg' },
        { src: '/static/image/banner_06.jpg' },
        { src: '/static/image/banner_07.jpg' },
        { src: '/static/image/banner_08.jpg' },
      ],
    };
  },
  created() {
    let that = this;
  },
  methods: {},
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/zhanzhu.vue